import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	popup: {
		maxWidth: 500,
	},
	description: {
		fontSize: 14,
		color: THEME.colors.text.light,
		lineHeight: 1.5,
		margin: '0 0 16px 0',
	},
	confirmText: {
		fontSize: 14,
		color: THEME.colors.text.main,
		fontWeight: 500,
		margin: '16px 0 0 0',
	},
	errorList: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
	},
	errorItem: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: 10,
		padding: 12,
		backgroundColor: THEME.colors.danger.light,
		borderRadius: THEME.common.borderRadius,
		border: `1px solid ${THEME.colors.danger.main}`,
	},
	errorIcon: {
		flexShrink: 0,
		marginTop: 2,
	},
	warningSection: {
		marginTop: 16,
		padding: 12,
		backgroundColor: THEME.colors.warning.light,
		borderRadius: THEME.common.borderRadius,
		border: `1px solid ${THEME.colors.warning.main}`,
	},
	warningTitle: {
		fontSize: 14,
		fontWeight: 600,
		color: THEME.colors.warning.dark,
		margin: '0 0 12px 0',
	},
	warningList: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	warningItem: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: 8,
		fontSize: 13,
		color: THEME.colors.warning.dark,
	},
	warningIcon: {
		flexShrink: 0,
		marginTop: 2,
	},
	actions: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 12,
		borderTop: `1px solid ${THEME.colors.border.light}`,
	},
});
